<template>
  <nav class="micarrito" id="micarrito" ref="cartNavigation">

    <div class="closeMyCart">CERRAR</div>

    <!-- Header -->
    <div class="box-header">
      <div class="title">Mi carrito</div>
      <div class="box-cantidad">
        Total de productos: <span class="cantidad">{{cart_total}}</span>.
      </div>
    </div>

    <!-- Product List -->
    <div class="box-product-list">

      <div v-for="item in cart_items" :key="item.product.code" class="box-item">
        <div class="item-box-photo">
          <a href="#" v-if="item.product.images">
            <img v-if="item.product.images" :src="item.product.images[0].url" class="item-photo">
            <img v-if="!item.product.images" src="/static/img/noimage.jpg" class="item-photo">
          </a>
        </div>
        <div class="item-box-description">
          <div class="item-title">{{item.product.description}}</div>
          <div class="item-code">{{item.product.code}}</div>
          <div class="item-price">
            <span v-if="hasDiscount(item.product)" class="original-price">{{item.product.price | currency }}</span>
            <span :class="{'discounted-price': hasDiscount(item.product)}">{{getEffectivePrice(item.product) | currency }} + IVA</span>
            <span v-if="hasDiscount(item.product)" class="discount-tag">-{{item.product.discount_percentage}}%</span>
          </div>
          <div class="item-cantidad"> Cantidad: <span class="numCantidad">{{item.quantity}} unidades</span></div>
        </div>
        <div class="cartQuitar" @click.prevent="removeFromCart(item)">
          <img src="/static/img/app/btn-close-grey.svg">
        </div>
      </div>


    </div>

    <!-- Footer -->
    <div class="box-footer">

        <div class="box-subtotal" v-if="discount_value>0">
            Subtotal. <span class="price pull-right"> {{cart_subtotal | currency }}</span>
        </div>

        <div class="box-subtotal" v-if="discount_value>0">
            Descuento. <span class="price pull-right">- ({{discount_value | currency }})</span>
        </div>

      <div class="box-subtotal" style="display:none;">

        Total. <span class="price pull-right">{{cart_total | currency }} + IVA</span>
      </div>


      <a class="btn-submit"  @click.prevent="goToCart" v-if="((cart_items.length) && (cart_total>=purchaseMin))" :class="{ 'loading': isLoading }" :disabled="isLoading">
        <span v-if="!isLoading">FINALIZAR COMPRA</span>
        <span v-else class="loader"></span>
      </a>
      <!--<div v-else>
        El minimo es {{purchaseMin | currency}} , te faltan {{ parseFloat(purchaseMin - cart_total ) | currency}}
      </div>-->

    </div>

  </nav>

</template>

<script>
  import Api from '@/Api'
  import { mapGetters } from 'vuex';

  export default {
    data(){
      return {
        categories:[],
        isLoading: false
      }
    },
    computed: {
      ...mapGetters(['user','isLogged','cart_total','cart_subtotal','cart_items','purchaseMin', 'discount_value'])
    },
    methods:{
      hasDiscount(product) {
        return product.enable_discount && product.discount_percentage > 0;
      },
      getEffectivePrice(product) {
        if (this.hasDiscount(product)) {
          return product.price * (1 - product.discount_percentage / 100);
        }
        return product.price;
      },
      async goToCart(){
        if (this.isLoading) {
          return;
        }

        this.isLoading = true;

        try {
          //this.$refs.cartNavigation
          $("nav.micarrito, .overlay-micarrito").removeClass("open");
          $("body").removeClass("lock");
          await this.$router.push({name: 'CartDetail'});
        } catch (error) {
          console.error('Error navigating to cart:', error);
        } finally {
          this.isLoading = false;
        }
      },
      removeFromCart(item){

        this.$store.dispatch("removeFromCart", {item}).then( success =>{

          if (this.cart_items.length<=0)
          {
            //AUTOHIDE WHEN THERE IS NO MORE PRODUCTS IN THE CART
            $("nav.micarrito, .overlay-micarrito").removeClass("open");
            $("body").removeClass("lock");
          }

        });
      }
    },
    mounted(){
    }
  }
</script>

<style scoped>
.btn-submit {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit.loading {
  cursor: not-allowed;
  opacity: 0.8;
}

.loader {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.item-price {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.original-price {
  font-size: 0.85em;
  color: #999;
  text-decoration: line-through;
}

.discounted-price {
  color: #e74c3c;
  font-weight: 600;
  font-size: 1.05em;
}

.discount-tag {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.75em;
  font-weight: bold;
  display: inline-block;
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Carrito.vue